import React from 'react';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import NavMenu from '../section/LoggedInNav.js';
import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';
import Sidebar from './Sidebar.js';

const DEFAULT_SIDEBAR_LINKS = [
  {
    label: 'Portal Dashboard',
    to: '/home',
    iconClass: 'bi-speedometer2',
    exact: true,
  },
  {
    label: 'Payments',
    to: '/payments',
    iconClass: 'bi-cash-coin',
  },
  {
    label: 'Messages & Alerts',
    to: '/main',
    iconClass: 'bi-chat-dots',
  },
  {
    label: 'My Documents',
    to: '/documents',
    iconClass: 'bi-folder2-open',
  },
  {
    label: 'Update Direct Deposit',
    href: 'https://www.metrohousingboston.org/wp-content/uploads/2019/08/Direct-Deposit-Form-update-8.12.19-fillable-1.pdf',
    iconClass: 'bi-file-earmark-arrow-down',
    external: true,
  },
  {
    label: 'Frequently Asked Questions',
    to: '/faq',
    iconClass: 'bi-question-circle',
  },
  {
    label: 'Settings',
    to: '/settings',
    iconClass: 'bi-gear',
  },
  {
    label: 'Log Out',
    action: 'signOut',
    iconClass: 'bi-box-arrow-right',
  },
];

const PortalPageLayout = ({
  user,
  children,
  showBanner = false,
  showSidebarForAuthenticated = true,
  sidebarLinks = DEFAULT_SIDEBAR_LINKS,
}) => {
  const { push } = useHistory();
  const shouldShowSidebar = Boolean(user && showSidebarForAuthenticated);

  const handleSidebarSignOut = async (event) => {
    if (event) {
      event.preventDefault();
    }

    await Auth.signOut();
    alert('Signed out');
    push('/public');
  };

  const resolvedSidebarLinks = sidebarLinks.map((link) => {
    if (link.action === 'signOut') {
      return {
        ...link,
        onClick: handleSidebarSignOut,
      };
    }

    return link;
  });

  return (
    <div className='App portal-page'>
      <NavMenu />
      {showBanner && <Banner />}

      <div className='portal-content-shell'>
        <div className={`portal-content-grid ${shouldShowSidebar ? 'has-sidebar' : 'no-sidebar'}`}>
          {shouldShowSidebar && (
            <Sidebar
              links={resolvedSidebarLinks}
              ariaLabel='Portal navigation'
            />
          )}
          <main className='portal-main-content'>
            {children}
          </main>
        </div>
      </div>

      <SITELINKS />
    </div>
  );
};

export default PortalPageLayout;
